import { getApiClient, initializeApiClient } from "../../apiService";

const UpdateProjectImpact = async (
  pI_ExpectedProjectImpactOnTargetGroupId,
  expectedSocialImpact,
  projectImpactOnTargetGroupSkillsAcquired,
  projectSustainabilityPlan,
  knowledgeTransferPlan,
  aI_ApplicationInformationId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/PI_ExpectedProjectImpactOnTargetGroup/UpdateExpectedProjectImpact`,
    {
      pI_ExpectedProjectImpactOnTargetGroupId:
        pI_ExpectedProjectImpactOnTargetGroupId,
      expectedSocialImpact: expectedSocialImpact,
      projectImpactOnTargetGroupSkillsAcquired:
        projectImpactOnTargetGroupSkillsAcquired,
      projectSustainabilityPlan: projectSustainabilityPlan,
      knowledgeTransferPlan: knowledgeTransferPlan,
      aI_ApplicationInformationId: aI_ApplicationInformationId,
    }
  );

  return response.data.result;
};

export default UpdateProjectImpact;
